import { useEffect, useMemo } from 'react';
import { Form, FormInstance, Select } from 'antd';

import { useAllDamageSchemasQuery } from 'types/atlas-graphql';

type DamageEditSchemaProps = {
  form: FormInstance;
  schemaId: string;
  onChange: (schemaId: string) => void;
  externalLoading: boolean;
};

export default function DamageEditSchema({
  form,
  schemaId,
  onChange,
  externalLoading,
}: DamageEditSchemaProps) {
  const { data, loading } = useAllDamageSchemasQuery();
  const damageSchemas = useMemo(() => data?.damageSchemas ?? [], [data]);

  useEffect(() => {
    const _schemaId =
      schemaId ?? damageSchemas.find(({ isDefault }) => isDefault)?.id ?? damageSchemas[0]?.id;
    if (_schemaId) {
      form.setFieldsValue({ schemaId: _schemaId });
      onChange(_schemaId);
    }
  }, [form, schemaId, onChange, damageSchemas]);

  return (
    <Form.Item
      label="Damage Schema"
      name="schemaId"
      style={damageSchemas?.length < 2 ? { visibility: 'hidden', height: 0, marginBottom: 0 } : {}}
      rules={[{ required: true, message: 'Please select a Schema' }]}
    >
      <Select
        className="testid-damage-schema-edit"
        style={{ width: '100%' }}
        allowClear={false}
        onChange={onChange}
        getPopupContainer={triggerNode => triggerNode.parentElement}
        loading={loading || externalLoading}
      >
        {damageSchemas.map(({ id, name, isDefault }) => (
          <Select.Option key={id} value={id}>
            {`${name}${isDefault ? ' (default)' : ''}`}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}
